import React from 'react'
import './volunteer.css';
import vforce from '../../assets/images/WhatsApp-Image-2020-10-16-at-14.25.50.jpeg';
import vforce_1 from '../../assets/images/IMG_3948-min.jpeg';



const Volunteer = () => {
    return (
        <div className="background-color">
            <div className="header volunteering"></div>
            <div id="projects" className="section">
                <div className="container">
                    <h1 className="gm-heading-1">Volunteer with V-Force</h1>
                    <p>Gammadda V-Force was launched with the objective of providing a
                        platform for the youth to place the interests of the country before
                        theirs and volunteer for a worthy cause. V-Force comprising of volunteers
                        from all over the country sets off to pre-planned locations to undertake their
                        responsibility of building the nation. <br /><br />
                        Newsfirst has recognized the critical contribution that volunteering makes to
                        build a strong and cohesive society that government cannot achieve by itself and has therefore supported volunteering as
                        the essential act of citizenship, a means for combating social exclusion, and promoting self help for community development.
                        It comes from the most basic of all values- people helping people and, in the process, helping each other. It emerges from
                        long-established Sri Lankan values, ancient traditions of sharing, philanthropy</p>
                </div>
            </div>
            <div id="projects" className="section universe">
                <div className="container">
                    <div className="row mb-5">
                        <div id="" className="col-md-6 col-12  content-wrapper-universe">

                            <h3 className="h3-universe">Volunteer as Individuals</h3>
                            <p className="p-left universe">The V-Force campaigns offer participants a full day of service,
                                learning and the opportunity to make life-long friends. V-Force Campaigns are one-day projects
                                to which volunteers are taken to pre-planned locations to undertake their responsibility of building the nation.<br /><br />‍</p>
                            <a href="https://www.vforce.lk/" target="_blank" className="button vforce w-button">Join Now</a>
                        </div>
                        <div className="col-md-6 col-12 order-md-last order-first mb-lg-0 mb-3">
                            <img src={vforce} alt="" className="image-4" />
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-6 col-12 mb-lg-0 mb-3">
                            <img src={vforce_1} alt="" className="image-4" />
                        </div>
                        <div className="col-md-6 col-12 content-wrapper-universe">
                            <h3 className="h3-universe">Volunteer as a Group</h3>
                            <p className="p-left universe">V-Force Teams hopes to mobilize young people into agents of change and transformation
                                within their own villages. Each Village Force conducts various service projects within its local community,
                                and participates in special projects involving other societies.V-Force Student Groups promotes student volunteering
                                and service learning and is aimed at encouraging civic behavior among young people.<br />‍<br />V-Force Corporate Groups
                                are teams of employees who partake in social activities on a voluntary basis on community-improving initiatives.<br />‍
                            </p>
                            <a href="https://www.vforce.lk/volunteer-as-a-group" target="_blank" className="button vforce w-button">Join as a Group</a>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Volunteer